import { ExternalLink } from "lucide-react";

export default function BookPreview({ src, title = "Sample pages" }) {
  return (
    <div className="brut-border bg-white overflow-hidden" data-testid="book-preview-container">
      <div className="bg-[#1F3D2A] text-white p-3 flex items-center justify-between flex-wrap gap-2">
        <div className="mono text-[10px] uppercase tracking-[0.3em] text-[#C77E3C]">{title}</div>
        <div className="flex items-center gap-3">
          <span className="mono text-[10px] uppercase tracking-[0.25em] text-white/60">Preview only</span>
          <a
            data-testid="book-preview-fullscreen"
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            className="mono text-[10px] uppercase tracking-[0.25em] hover:text-[#C77E3C] flex items-center gap-1"
          >
            Fullscreen <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>
      <div className="bg-[#EAEAEA]">
        <iframe
          data-testid="book-preview-iframe"
          title={title}
          src={`${src}#toolbar=0&navpanes=0&view=FitH`}
          className="w-full h-[600px] border-0 block"
        />
      </div>
      <div className="bg-[#FDF3E9] border-t-2 border-[#1F3D2A] px-4 py-3 mono text-[10px] uppercase tracking-[0.25em] text-[#555]">
        Sample pages only — buy the book to unlock the full read.
      </div>
    </div>
  );
}
